// extracted by mini-css-extract-plugin
module.exports = {"slides":"BXkt","headerWrap":"BXkv","header":"BXap","headerLink":"BXkx","nav":"BXkz","navBtn":"BXk1","navBtnNext":"BXk3","disabled":"BXib","sliderWrapper":"BXk5","visible":"BXk7"};